import angularJwt from 'angular-jwt';
import ngCookies from 'angular-cookies';

import { NativePlatformServiceModule } from 'services/access/nativePlatform/nativePlatform.service';

export const MobileAnalyticsServiceModule = angular
    .module('app.services.tracking.mobileAnalytics', [NativePlatformServiceModule, angularJwt, ngCookies])
    .service('mobileAnalyticsService', ($window, nativePlatformService, jwtHelper, $cookies) => {
        const service = {
            trackEvent
        };

        function trackEvent(eventName, data) {
            // Get user info and append it to data
            let userData = {};
            const token = $cookies.get('id_token');
            if (token) {
                const decoded = jwtHelper.decodeToken(token);
                if (decoded) {
                    userData.tenant = decoded.tenant;
                    userData.user_id = decoded.user_id;
                }
            }
            Object.assign(data, userData);

            const kit = nativePlatformService.getKit($window);

            if (nativePlatformService.isIOS && nativePlatformService.supports($window, 'AnalyticsEventHandler')) {
                kit.messageHandlers.AnalyticsEventHandler.postMessage({
                    eventName,
                    data
                });
            }
            if (nativePlatformService.isAndroid && nativePlatformService.supports($window, 'handleAnalyticsEvent')) {
                kit.handleAnalyticsEvent(JSON.stringify({
                    eventName,
                    data
                }));
            }
        }

        return service;
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/tracking/mobileApps/mobileAnalytics.service.js